import { graphql } from "../generated/gql";

export const GetCurrentUser = graphql(`
  query GetCurrentUser {
    getAgentV2 {
      ID
      firstName
      lastName
      companyID
      language
      fullName
      email
      role
      roles {
        name
      }
      createdAt
    }
  }
`);
